import { memo } from "react";

import {
  FEATURE_FLAGS,
  useFeatureFlags,
} from "@hl/shared-features/lib/features/auth/hooks";
import { AppSEO } from "@hl/shared-features/lib/features/layout/AppSEO";
import { Container, Space, Stack, Title } from "@mantine/core";

import FeatureNotAvailable from "../layout/FeatureNotAvailable";

const TokenDashboard = () => {
  const showDebugPages = useFeatureFlags(FEATURE_FLAGS.SHOW_DEBUG_PAGES);

  if (!showDebugPages) {
    return <FeatureNotAvailable />;
  }

  return (
    <Container size="sm">
      <AppSEO title="Tokens" />
      <Title order={4}>Debug pages</Title>
      <Space h={24} />
      <Stack spacing="lg">none right now</Stack>
    </Container>
  );
};

export default memo(TokenDashboard);
